import { NewApp } from "NewApp";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./style.css";
import "./tailwind-output.css";
import "./shadcn-tokens.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<NewApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
